import React, { useEffect } from "react";
import {
  FormControl,
  Grid,
  Typography,
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import { FormikProps, getIn } from "formik";
import useTranslation from "../../../../hooks/translations";
import { Country, MobileMoneyCountryOption, PaymentProviderData } from "../../../../types";

interface ProviderSectionProps {
  payment: PaymentProviderData[];
  formik: any;
  providerType: string;
  setPaymentProviderId: (id: string) => void;
  setPricingId: (id: string) => void;
  radioChecked: boolean;
  setRadioChecked: (checked: boolean) => void;
  setPaymentProviderName: (name: string) => void;
  country?: (Country | null);
}

const ProviderSection: React.FC<ProviderSectionProps> = ({
  payment,
  formik,
  providerType,
  setPaymentProviderId,
  setPricingId,
  radioChecked,
  setRadioChecked,
  setPaymentProviderName,
  country,
}) => {
  const { t } = useTranslation();

  const providerItem = payment?.find((item: any) => item.name === providerType);
    let providerEntries: any[] = [];

    if (providerType === "Mobile Money" && providerItem && country) {

      const countryOption = providerItem.paymentOptions?.find(
        (opt: any) => opt.countryCode === country?.code
      )as MobileMoneyCountryOption | undefined;
      providerEntries = countryOption?.paymentProviders || [];
    } else {
      providerEntries = providerItem?.paymentOptions || [];
    }

  return (
    <Box>
      <Grid item>
        <FormControl className={"fieldset-options"} component="fieldset">
          <Typography component="legend" className={"fieldTitleSecondary"}>
            {t("provider")}{" "}
            <span style={{ fontSize: 14, color: "red" }}>*</span>
          </Typography>
          {providerEntries.map((entry: any) =>
            entry.paymentProviderInfo?.enabled && (
                  <RadioGroup
                    key={entry.paymentProviderInfo.id.uuid}
                    aria-required={true}
                    className={"radioBlockWrapper"}
                    name="paymentProviderId"
                    aria-label="payment"
                    row
                    onChange={() =>
                      formik.setFieldValue(
                        "paymentProviderId",
                        entry?.paymentProviderInfo?.id
                      )
                    }
                    onBlur={formik?.handleBlur}
                    value={getIn(formik?.values, "paymentProviderId.uuid")}
                  >
                    <FormControlLabel
                      key={entry?.paymentProviderInfo?.id?.uuid}
                      id={entry?.paymentProviderInfo?.id?.uuid}
                      onClick={() => {
                        setPaymentProviderId(entry?.paymentProviderInfo?.id);
                        formik.setFieldValue(
                          "paymentProviderId",
                          entry?.paymentProviderInfo?.id
                        );
                        setPricingId(entry?.paymentProviderInfo?.customerPricingId);
                        setPaymentProviderName(entry?.paymentProviderInfo?.name);
                      }}
                      value={entry?.paymentProviderInfo?.id}
                      control={
                        <Radio
                          name={entry?.paymentProviderInfo?.name}
                          checked={
                            radioChecked === entry?.paymentProviderInfo?.name &&
                            true
                          }
                          onClick={(e: any) => setRadioChecked(e.target.name)}
                          className={`radio radio-${entry?.paymentProviderInfo?.name}`}
                        />
                      }
                      label={
                        <img
                          style={{
                            maxWidth: "50px",
                            height: "auto",
                            marginRight: "10px",
                            display: "inline-block",
                            verticalAlign: "middle",
                            borderRadius: "5px",
                          }}
                          src={entry?.paymentProviderInfo?.logoUrl}
                          alt={entry?.paymentProviderInfo?.name}
                          loading="lazy"
                        />
                      }
                    />
                  </RadioGroup>
                )
            )}
        </FormControl>
        {
          <Typography
            pb={4}
            pl={2}
            style={{
              color: "#d32f2f",
              fontSize: "0.75rem",
            }}
          >
            {typeof formik?.errors.paymentProviderId === "string"
              ? formik.errors.paymentProviderId
              : ""}
            {formik?.errors.paymentProviderId?.uuid}
          </Typography>
        }
      </Grid>
    </Box>
  );
};

export default ProviderSection;
